import React, { useState, useEffect } from 'react';
import { Layout, Menu, Button, Dropdown, message, ConfigProvider } from 'antd';
import { 
    LogoutOutlined, UserOutlined, MenuFoldOutlined, MenuUnfoldOutlined,
    FileTextOutlined, SearchOutlined, BarChartOutlined, TeamOutlined
} from '@ant-design/icons';
import { useNavigate, Outlet, useLocation } from 'react-router-dom';
import './MainLayout.css';

const { Header, Sider, Content } = Layout;

const MainLayout = () => {
    const [collapsed, setCollapsed] = useState(false);
    const [user, setUser] = useState(null);
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const userData = localStorage.getItem('user');
        if (userData) {
            setUser(JSON.parse(userData));
        }
    }, []);

    const handleLogout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        message.success('已退出登录');
        navigate('/login');
    };

    const getMenuItems = () => {
        const baseItems = [
            {
                key: '/accident-filing',
                icon: <FileTextOutlined />,
                label: '事故立案',
            },
            {
                key: '/accident-query',
                icon: <SearchOutlined />,
                label: '事故查询',
            }
        ];

        // 只有特定角色显示事故统计
        if (["admin", "advanced_user", "manager"].includes(user?.role)) {
            baseItems.push({
                key: '/statistics',
                icon: <BarChartOutlined />,
                label: '事故统计',
            });
        }

        if (user?.role === 'admin' || user?.role === 'manager') {
            baseItems.push({
                key: '/user-management',
                icon: <UserOutlined />,
                label: '用户管理',
            });
            // Add User Units management menu entry (admin only)
            if (user?.role === 'admin') {
                baseItems.push({
                    key: '/user-units',
                    icon: <TeamOutlined />,
                    label: '用户单位管理',
                });
            }
            // Data dictionaries (admin and manager)
            baseItems.push({
                key: '/dictionaries',
                icon: <BarChartOutlined />,
                label: '数据字典管理',
            });
        }

        return baseItems;
    };

    const userMenu = {
        items: [
            {
                key: 'change-password',
                label: '修改密码',
                onClick: () => {
                    navigate('/change-password');
                }
            },
            {
                key: 'logout',
                label: '退出登录',
                icon: <LogoutOutlined />,
                onClick: handleLogout
            }
        ]
    };

    return (
        <ConfigProvider theme={{
            token: {
                fontFamily: '仿宋, serif'
            }
        }}>
            <Layout className="main-layout">
                <Sider trigger={null} collapsible collapsed={collapsed} width={200} theme="dark">
                    <div className="logo">
                        {!collapsed && <h2>道路交通事故管理</h2>}
                    </div>
                    <Menu
                        theme="dark"
                        mode="inline"
                        selectedKeys={[location.pathname]}
                        items={getMenuItems()}
                        onClick={(e) => navigate(e.key)}
                    />
                </Sider>

                <Layout>
                    <Header className="header">
                        <Button
                            type="text"
                            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                            onClick={() => setCollapsed(!collapsed)}
                            style={{ fontSize: '16px' }}
                        />
                        <div className="header-right">
                            <span className="user-info">
                                {user?.real_name || user?.username}
                            </span>
                            <Dropdown menu={userMenu} trigger={['click']}>
                                <Button type="text" icon={<UserOutlined />} />
                            </Dropdown>
                        </div>
                    </Header>

                    <Content className="content">
                        <Outlet />
                    </Content>
                </Layout>
            </Layout>
        </ConfigProvider>
    );
};

export default MainLayout;
